module.exports = __webpack_public_path__ + "static/feather-2-e975af16a4e1bd8e7fb6de9a03eb904b.png";